<template>
  <div class="NewsDetails">
    <banner :img="bannerImg" />
    <!-- <div v-html="htmlContent"></div> -->
    <div class="NewsDetails-product">
      <div class="NewsDetails-product-content">
        <!-- <img v-lazy="newsIdList.coverImg" alt /> -->
        <p class="product-title">{{newsIdList.title}}</p>
        <p class="product-time">{{newsIdList.occurenceTime || ''}}</p>
        <p class="product-content" v-html="htmlContent"></p>
      </div>
    </div>
  </div>
</template>

<script>
import { getArticleDetail,getWebsiteConfigList } from '../api';
import Banner from "../components/Banner";
export default {
  name: "NewsDetails",
  components: {
    Banner
  },
  data() {
    return {
      pid: 0,
      newsIdList: {},
      htmlContent: '',
      bannerImg: '',
      fromPath: ''
    };
  },
  beforeRouteEnter(to,from,next) {
    next(vm => {
      vm.fromPath = from.path
    })
  },
  created() {
    this.pid = this.$route.params.id;
    const menu = [
      {path: 'about'},
      {path: 'service'},
      {path: 'case'},
      {path: 'product'},
      {path: 'news'},
    ]
    getWebsiteConfigList().then(res => {
      // console.log(this.$route.params, this.fromPath)
      if (this.fromPath !== '/' && this.fromPath) {
        const path = menu.find(item => this.fromPath.includes(item.path)).path
        this.bannerImg = res.data.some(item => item.code === `bg_banner_${path}`) ? res.data.find(item => item.code === `bg_banner_${path}`).title : ''
      }
      // this.bannerImg = res.data.some(item => item.code === 'bg_banner_detail') ? res.data.find(item => item.code === 'bg_banner_detail').title : ''
      getArticleDetail(this.pid).then(re => {
        this.newsIdList = re.data
        this.htmlContent = re.data.htmlContent
        if (this.fromPath === '/') {
          this.bannerImg = res.data.some(item => item.code === `bg_banner_${re.data.cateId === '6' ? 'case' : 'news'}`) ? res.data.find(item => item.code === `bg_banner_${re.data.cateId === '6' ? 'case' : 'news'}`).title : ''
        }
      })
    })
  },
  mounted() {
    // this.loadData();
  },
  methods: {
    loadData() {
      this.$http
        .get(`News/GetNewsById/${this.pid}`)
        .then(response => {
          //console.log(response);
          this.newsIdList = response.data;
          window.console.log(this.newsIdList);
        })
        .catch(function(error) {
          window.console.log(error);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.NewsDetails {
  width: 100%;
  height: 100%;
  //overflow: hidden;
  // background-color: #14679f;
  &-product {
    width: 1240px;
    margin: 0 auto;
    background-color: #fff;
    // border: 1px solid red;
    &-content {
      width: 1240px;
      // margin: 0 auto;
      // display: flex;
      // flex-direction: column;
      // align-items: flex-start;
      padding: 30px;
      box-sizing: border-box;
      img {
        width: 100%;
        //height: 500px;
      }
      .product-title {
        font-size: 25px;
        color: #e13834;
        padding: 20px 0;
        text-align: center;
      }
      .product-time {
        text-align: center;
      }
      .product-content {
        // text-align: center;
        font-size: 17px;
        // font-weight: bolder;
        padding: 20px 0;
        width: 900px;
        margin: 0 auto;
        line-height: 30px;
        ::v-deep {
          img {
            width: 100% !important;
            height: auto !important;
          }
          div {
            width: 900px !important;
          }
          .xn_c_prodv_5_wrap {
            width: 100% !important;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 997px) {
  .NewsDetails {
    &-product {
      width: calc(100% - 20px);
      &-content {
        width: 100%;
        .product-content {
          width: 100%;
          ::v-deep {
            div, .xn_c_prodv_5_wrap {
              width: 100% !important;
            }
            .EIMS_C_10_1_BigImageDivH {
              margin: 0 5px !important;
              #EIMS_C_10_1_IMG0 {
                width: calc(100% - 20px) !important;
              }
            } 
          }
        }
      }
    }
  }
}
</style>